

import {  Select } from '@alifd/next';
import { SelectProps } from '@alifd/next/types/select/index';
import wrapper from './next-wrapper';

export type BLProFormSelectProps = SelectProps;

const BLProFormSelect = wrapper<BLProFormSelectProps>(Select, 'BLProFormSelect');

export default BLProFormSelect;
